<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">American Coastguards, UNST &amp; The B.P. Oily Blacks (1978)</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li><li id="toc-li-3"><a href="#/text/ch003#acknowledgement">Acknowledgement</a></li><li id="toc-li-4"><a href="#/text/ch004#section"></a></li></ol></div><a href="#/text/ch004#section">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5fe7c9a2